<template lang="pug">
#modal-visualizar-diagnostico-socioambiental-territorio-monitoramento(
    v-if='show && territorio !== {}'
)
    el-dialog(
        :visible.sync='show',
        :before-close='closeModal',
        :close-on-click-modal='false',
        width='95%'
    )
        .template(slot='title')
            .box-header
                .box-header--title
                    h1
                        | Diagnóstico Socioambiental
        .conteudo
            .conteudo-esquerda
                .territorio
                    h3
                        .dados-label
                            i.flow.flow-shape
                            b Território
                    span {{ territorio.nome }}

                    h4.mt-2 Data de realização do diagnóstico:
                        span.pl-2.font {{ territorio.dataDiagnostico }}

                    div(v-if='territorio.informacoes_gerais !== null')
                        h4.mt-2.mb-3 Informações Gerais:
                        h4.pl-3.informacoes-gerais(
                            v-if='territorio.informacoes_gerais.situacao'
                        ) Situação: {{ validaSituacao(territorio.informacoes_gerais.situacao) }}
                        h4.pl-3.informacoes-gerais(
                            v-if='territorio.informacoes_gerais.area_ha'
                        ) Área (ha): {{ territorio.informacoes_gerais.area_ha }}
                        h4.pl-3.informacoes-gerais Bioma: {{ territorio.informacoes_gerais.bioma ? territorio.informacoes_gerais.bioma : '--' }}
                        h4.pl-3.informacoes-gerais Faixa de fronteira: {{ territorio.informacoes_gerais.faixa_fronteira !== null ? (territorio.informacoes_gerais.faixa_fronteira ? 'Sim' : 'Não') : '--' }}

                    .mt-2
                        h4 Resultado da Análise
                        DiagnosticoSocioambiental(
                            :dadosConsulta='territorio',
                            :habilitar-opacidade='true',
                            @index-aberto='atualizarRestricaoMapa'
                        )
                .representantes.mt-2(
                    v-for='(representante, index) in this.territorio.representantes'
                )
                    h3.mb-3
                        .dados-label
                            i.flow.flow-user-second
                            b Pessoa
                    span {{ representante.nomeRepresentante }}
                    DiagnosticoSocioambiental(
                        :indexCollapse='index',
                        :dadosConsulta='representante',
                        :cpfCnpj='representante.documento',
                        :habilitar-opacidade='true',
                        @index-aberto='atualizarRestricaoMapaCpf'
                    )

                .territorio.mt-2(
                    v-for='(car, index) in this.territorio.dadosCar'
                )
                    h3.mb-3
                        .dados-label
                            i.flow.flow-shape
                            b CAR
                    span {{ car.imovel.codigo }}
                    DiagnosticoSocioambiental(
                        :indexCollapse='index',
                        :dadosConsulta='car',
                        :habilitar-opacidade='true',
                        v-bind:car='getCar(car.imovel.codigo)',
                        @index-aberto='atualizarRestricaoMapaCars'
                    )

            .conteudo-direita
                mapa(
                    :height='"100%"',
                    idMapa='MapaModalVisualizarDiagnosticoSociambientalTerritorioMonitoramento',
                    :key='keyMapa',
                    :showStatesLayers='false',
                    :mapLayersConfigs='camadasMapa',
                    :mapConfig='mapConfig',
                    :camadaCentralizadaNome='camadaCentralizadaNome',
                    :atualizarMapa='false'
                )
</template>

<script>
import Mapa from '@/components/MapaLeaflet.vue';
import DiagnosticoSocioambiental from '@/components/diagnosticoSocioambiental/index.vue';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';
import centroidFromGeoJSON from '@/utils/centroidFromGeoJSON';

export default {
    name: 'ModalVisualizarDiagnosticoSocioambientalTerritorioMonitoramento',

    props: {
        territorio: {
            type: Object,
            required: true,
            default() {
                return {};
            }
        },
        show: {
            default: false,
            type: Boolean
        }
    },
    emits: ['close'],
    components: {
        Mapa,
        DiagnosticoSocioambiental
    },

    watch: {
        show(_new, _old) {
            if (_new) {
                this.configureLayersMapa();
            }
        }
    },

    data() {
        return {
            camadasMapa: [],
            mapConfig: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true
                },
                inspecionar: false,
                diagnostico: true
            },
            keyMapa: 1,
            camadaCentralizadaNome: null,
            indexUltimaRestricaoAbertaTerritorio: null,
            indexUltimaRestricaoAbertaRepresentante: null,
            indexUltimaRestricaoAbertaCar: null,
            areasRestricao: []
        };
    },
    methods: {
        closeModal() {
            this.camadasMapa = [];
            this.$emit('close');
        },
        validaSituacao(situacao) {
            switch (situacao) {
                case 'AT':
                    return 'Ativo';
                case 'PE':
                    return 'Pendente';
                case 'SU':
                    return 'Suspenso';
                case 'CA':
                    return 'Cancelado';
            }
        },
        getCar(car) {
            if (car.toUpperCase().startsWith('PA')) {
                return car;
            }
        },
        configureLayersMapa() {
            let layerAreaMonitorada = {
                style: getEstiloGeometria('area'),
                name: 'Área Monitorada',
                geoJson: this.territorio.geometria,
                tooltip: 'Território: ' + this.territorio.nome,
                featureGroup: true
            };

            this.camadasMapa.push(layerAreaMonitorada);

            if (this.territorio.dadosCar) {
                this.territorio.dadosCar.forEach(c => {
                    let car = {
                        style: getEstiloGeometria('car'),
                        name: 'CAR',
                        geoJson: c.imovel.geometria,
                        tooltip: 'CAR: ' + c.imovel.codigo,
                        featureGroup: true
                    };
                    this.camadasMapa.push(car);
                });
            }
        },

        atualizarRestricaoMapa(restricao, indexCollapse, indexCollapseRow) {
            this.areasRestricao = [];

            const tagRestricaoRemove = `${this.indexUltimaRestricaoAbertaTerritorio}-territorio`;
            this.camadasMapa = this.camadasMapa.filter(
                l => l.tagRestricao !== tagRestricaoRemove
            );

            if (indexCollapseRow !== '') {
                this.indexUltimaRestricaoAbertaTerritorio = indexCollapseRow;
                this.areasRestricao = {
                    areas: this.territorio.diagnosticos[indexCollapseRow]
                        .geometria,
                    camada: this.territorio.diagnosticos[indexCollapseRow]
                        .camada
                };

                const tagRestricaoAdd = `${indexCollapseRow}-territorio`;
                this.mostrarAreasDiagnosticoNoMapa(tagRestricaoAdd, restricao);
            }
        },

        atualizarRestricaoMapaCpf(restricao, indexCollapse, indexCollapseRow) {
            this.areasRestricao = [];

            const indexTagRemove =
                this.indexUltimaRestricaoAbertaRepresentante != null
                    ? this.indexUltimaRestricaoAbertaRepresentante
                    : indexCollapseRow;
            const tagRestricaoRemove = `${indexCollapse}-representante-${indexTagRemove}`;
            this.camadasMapa = this.camadasMapa.filter(
                l => l.tagRestricao !== tagRestricaoRemove
            );

            if (indexCollapseRow !== '') {
                this.indexUltimaRestricaoAbertaRepresentante = indexCollapseRow;

                if (
                    this.territorio.representantes[indexCollapse].diagnostico[
                        indexCollapseRow
                    ]
                ) {
                    this.areasRestricao = {
                        areas: this.territorio.representantes[
                            indexCollapse
                        ].diagnostico[indexCollapseRow].resultados.map(
                            resultado => {
                                if (resultado.geometria || resultado.geometry) {
                                    return (
                                        resultado.geometria ||
                                        resultado.geometry
                                    );
                                } else {
                                    return this.territorio.geometria;
                                }
                            }
                        ),
                        camada: this.territorio.representantes[indexCollapse]
                            .diagnostico[indexCollapseRow].camada
                    };
                }

                const tagRestricaoAdd = `${indexCollapse}-representante-${indexCollapseRow}`;
                this.mostrarAreasDiagnosticoNoMapa(tagRestricaoAdd, restricao);
            }
        },

        atualizarRestricaoMapaCars(restricao, indexCollapse, indexCollapseRow) {
            this.areasRestricao = [];

            const indexTagRemove =
                this.indexUltimaRestricaoAbertaCar !== null
                    ? this.indexUltimaRestricaoAbertaCar
                    : indexCollapseRow;
            const tagRestricaoRemove = `${indexCollapse}-car-${indexTagRemove}`;
            this.camadasMapa = this.camadasMapa.filter(
                l => l.tagRestricao !== tagRestricaoRemove
            );
            if (indexCollapseRow !== '') {
                this.indexUltimaRestricaoAbertaCar = indexCollapseRow;
                if (
                    this.territorio.dadosCar[indexCollapse].diagnosticos[
                        indexCollapseRow
                    ]
                ) {
                    this.areasRestricao = {
                        areas: this.territorio.dadosCar[
                            indexCollapse
                        ].diagnosticos[indexCollapseRow].resultados.map(
                            resultado =>
                                resultado.geometria || resultado.geometry
                        ),
                        camada: this.territorio.dadosCar[indexCollapse]
                            .diagnosticos[indexCollapseRow].camada
                    };
                }

                const tagRestricaoAdd = `${indexCollapse}-car-${indexCollapseRow}`;
                const group = `grupo-restricoes-${indexCollapse}-${indexCollapseRow}`;
                this.mostrarAreasDiagnosticoNoMapa(
                    tagRestricaoAdd,
                    group,
                    restricao
                );
            }
        },

        mostrarAreasDiagnosticoNoMapa(tagRestricao, group, restricao) {
            const opacidade =
                this.areasRestricao.camada.opacidade >= 0.0
                    ? this.areasRestricao.camada.opacidade / 200
                    : 0.5;

            this.areasRestricao.areas.forEach((area, index) => {
                let layerAreaDiagnostico;
                if (
                    restricao &&
                    restricao.index === index &&
                    restricao.overOrLeave === 'over'
                ) {
                    layerAreaDiagnostico = {
                        style: {
                            color: 'orange',
                            weight: 1,
                            fill: true,
                            opacity: opacidade,
                            fillOpacity: opacidade
                        },
                        name: `AreaDiagnostico ${index}`,
                        tagRestricao,
                        group,
                        geoJson: area
                    };
                } else {
                    layerAreaDiagnostico = {
                        style: {
                            color: 'red',
                            weight: 1,
                            fill: true,
                            opacity: opacidade,
                            fillOpacity: opacidade
                        },
                        name: `AreaDiagnostico ${index}`,
                        tagRestricao,
                        group,
                        geoJson: area
                    };
                }

                this.camadasMapa.push(layerAreaDiagnostico);

                const pin = L.icon({
                    iconUrl:
                        'https://lyra-v1.s3.amazonaws.com/Pin+da+restricao.png',
                    iconSize: [18, 18]
                });

                this.camadasMapa.push({
                    name: `CentroidDiagnostico ${index}`,
                    icon: pin,
                    tagRestricao,
                    group,
                    geoJson: centroidFromGeoJSON.get(area)
                });
            });

            if (restricao) {
                this.camadaCentralizadaNome = this.camadasMapa.filter(
                    l =>
                        l.geoJson === this.areasRestricao.areas[restricao.index]
                )[0].name;
            }
        }
    }
};
</script>

<style lang="scss">
#modal-visualizar-diagnostico-socioambiental-territorio-monitoramento {
    .el-dialog__wrapper {
        top: -15px !important;
        margin: 0 0 0px 35px !important;
    }
    .el-dialog {
        margin-top: 90px !important;
        .el-dialog__header {
            background: var(--operation-awaiting-approval);
            padding: 20px;
            padding-bottom: 10px;
            .box-header {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                .box-header--icon {
                    margin-right: 10px;
                }
                .box-header--title {
                    font-size: 20px;
                }
                .mdi:before,
                .mdi-set {
                    font-size: 19px;
                }
            }
        }
        .el-dialog__body {
            padding: 10px 20px;
        }

        .conteudo {
            display: flex;
            height: 700px;

            .conteudo-esquerda {
                color: var(--primary-font-color);
                width: 40%;
                overflow-y: auto;
                .dados-label i {
                    padding-right: 5px;
                }
                .territorio {
                    height: auto;
                }
                #diagnostico-socioambiental {
                    padding: 5px 20px;
                }
            }
            .conteudo-direita {
                width: 60%;
                padding-left: 5px;
            }
        }
        .font {
            font-size: 14px;
        }
    }
}
</style>
